import update from 'immutability-helper'
import clsx from 'clsx'
import React, {useContext} from 'react'
import Box from '@mui/material/Box'

import {TeacherContext} from 'teacher/context'
import useStyles from './multiple-choice/styles'
import Choice from './multiple-choice/choice'
import AddAnswer from './multiple-choice/add-answer'

import Editor from 'components/quiz/components/editable-html'

import {uuid} from 'helpers/utils'

export default function MultipleChoiceQuestion (props) {

  const {index, questionPath, onPropertyChange, updateProperties} = props

  const context = useContext(TeacherContext)
  const {translate, at} = context
  const [question] = at(questionPath) 


  const classes = useStyles()
	const config = {readonly: false}
  const premiseText = question.premise.html || ''

  function handlePremiseChanged (html, textpremise) {
    const premise = {html}
    updateProperties(
      {id: question.id, premise, textpremise},
      {premise: {$set: premise}, textpremise: {$set: textpremise}}
    )
  }

  function handleChoiceMove (drag, hover) {
    const [question] = at(questionPath)
    const choice = question.answer.choices[drag]
    updateProperties(
      false,
      {answer: {choices: {$splice: [[drag, 1], [hover, 0, choice]]}}}
    )
  }

  function handleChoiceDrop () {
    const [question] = at(questionPath)
    const answer = question.answer
    updateProperties({id: question.id, answer})
  }

  function handleAddAnswer () {
    const [question] = at(questionPath)
    const newChoice = {html: '', correct: false, id: uuid()}
    const command = question.answer.choices ? '$push' : '$set'
    const updateCommand = {answer: {choices: {[command]: [newChoice]}}}
    const {answer} = update(question, updateCommand)
    updateProperties({id: question.id, answer}, updateCommand)
  }

  function handleDeleteChoice (id) {
    const [question] = at(questionPath)
    const index = question.answer.choices.findIndex(c => c.id == id)
    const updateCommand = {answer: {choices: {$splice: [[index, 1]]}}}
    const {answer} = update(question, updateCommand)
    updateProperties({id: question.id, answer}, updateCommand)
  }

  function handleChoiceTextChange (id, html) {
    const [question] = at(questionPath)
    const index = question.answer.choices.findIndex(c => c.id == id)
    const updateCommand = {answer: {choices: {[index]: {html: {$set: html}}}}}
    const {answer} = update(question, updateCommand)
    updateProperties({id: question.id, answer}, updateCommand)
  }

  function handleChoiceCorrectChange (id, correct) {
    const [question] = at(questionPath)
    const index = question.answer.choices.findIndex(c => c.id == id)
    const updateCorrect = {answer: {choices: {[index]: {correct: {$set: correct}}}}}
    const {answer}= update(question, updateCorrect)
    updateProperties({id: question.id, answer}, updateCorrect)
  }


  return (
    <Box className={clsx(classes.root, "question", "multiple-choice")}>
      <Box className={clsx(classes.premise, "premise")}>
        <Box className="label">{translate('premise')}:</Box>
        <Editor
          context={context}
          html={premiseText}
          onChange={handlePremiseChanged}
        />
      </Box>
      <Box className={clsx(classes.answer, "answer")}>
        <Box className="label">{translate('quiz-options')}:</Box>
        <Box className="choices">
          {question.answer.choices && question.answer.choices.map((choice, index, {length}) => {
            return (<Choice
              key={choice.id}
              onChoiceMove={handleChoiceMove}
              onChoiceDropped={handleChoiceDrop}
              onChoiceTextChange={handleChoiceTextChange}
              onChoiceCorrectChange={handleChoiceCorrectChange}
              onDeleteChoice={handleDeleteChoice}
              questionCount={length}
              {...{index, choice, context, question}}
            />)
          })}
        </Box>
        <AddAnswer
          context={context}
          question={question}
          index={index}
          onAddAnswer={handleAddAnswer}
        />
     </Box>
    </Box>
  )
}
